import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const services = [
    { name: "Staff Engagement", href: "/staff-engagement" },
    { name: "Training", href: "/training" },
    { name: "Health & Safety", href: "/health-safety" },
    { name: "Recruitment", href: "/recruitment" },
  ];

  const company = [
    { name: "Case Studies", href: "/case-studies" },
    { name: "Your Comms", href: "/your-comms" },
    { name: "Funding", href: "/funding" },
    { name: "Why Us", href: "/why-us" },
    { name: "Contact", href: "/contact" },
  ];

  return (
    <footer data-testid="footer" className="bg-[#0a0a0a] border-t border-[#1F1F1F]">
      <div className="container mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_people-comms-hub/artifacts/oukn6zco_ICA%20LOGO%20TRANSPARENT%20LOW%20RES.png" 
                alt="Internal Comms Agency" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-[#B3B3B3] text-sm leading-relaxed mb-6">
              Transforming internal communications through strategic video production, 
              compelling design, and powerful storytelling.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display text-lg tracking-wider text-white mb-6">
              SERVICES
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.href}>
                  <Link
                    to={service.href}
                    data-testid={`footer-${service.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-[#B3B3B3] hover:text-[#00E5FF] transition-colors text-sm"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-display text-lg tracking-wider text-white mb-6">
              COMPANY
            </h4>
            <ul className="space-y-3">
              {company.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    data-testid={`footer-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-[#B3B3B3] hover:text-[#00E5FF] transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-lg tracking-wider text-white mb-6">
              GET IN TOUCH
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#00E5FF] mt-0.5 flex-shrink-0" />
                <a
                  href="mailto:info@yellowagency.co.uk"
                  data-testid="footer-email"
                  className="text-[#B3B3B3] hover:text-[#00E5FF] transition-colors text-sm"
                >
                  info@yellowagency.co.uk
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#00E5FF] mt-0.5 flex-shrink-0" />
                <a
                  href="tel:+441514272900"
                  data-testid="footer-phone"
                  className="text-[#B3B3B3] hover:text-[#00E5FF] transition-colors text-sm"
                >
                  (+44) 0151 427 2900
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#00E5FF] mt-0.5 flex-shrink-0" />
                <span className="text-[#B3B3B3] text-sm">
                  C/O The Yellow Agency, 2nd Floor, Consortia House, 6 Columbus Quay, Liverpool L3 4DB
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#1F1F1F] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#666] text-sm">
            © {new Date().getFullYear()} The Internal Comms Agency. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-[#666] hover:text-[#B3B3B3] transition-colors text-sm">
              Privacy Policy
            </a>
            <a href="#" className="text-[#666] hover:text-[#B3B3B3] transition-colors text-sm">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
